// import * as yup from "yup";

// export const applicationSchema = yup.object().shape({
//   name: yup.string().required("Name is required"),
//   fatherName: yup.string().required("Father name is required"),
//   motherName: yup.string().required("Mother name is required"),
//   wifeName: yup.string().nullable(),
//   birthdate: yup.date().required("Birthdate is required"),
//   address: yup.string().required("Address is required"),
//   mobile: yup
//     .string()
//     .matches(/^[0-9]{10}$/, "Mobile must be 10 digits")
//     .required("Mobile is required"),
//   whatsappMobile: yup.string().matches(/^[0-9]{10}$/, "WhatsApp mobile must be 10 digits").nullable(),
//   email: yup.string().email("Invalid email").required("Email is required"),
//   aadharNo: yup.string().matches(/^[0-9]{12}$/, "Aadhar must be 12 digits").nullable(),
//   panNo: yup.string().matches(/^[A-Z0-9]{10}$/, "Invalid PAN").nullable(),
//   voterId: yup.string().nullable(),
//   drivingLicense: yup.string().nullable(),
//   job: yup.string().nullable(),
//   duration: yup.string().nullable(),
//   amount: yup.number().positive("Amount must be positive").required("Amount is required"),
//   purchaseType: yup.string().required("Purchase type is required"),
//   paymentStatus: yup.string().oneOf(["active", "inactive"]).nullable()
// });
import * as yup from "yup";

export const applicationSchema = yup.object().shape({
  name: yup
    .string()
    .required("Name is required"),

  mobile: yup
    .string()
    .required("Mobile number is required")
    .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits"),

  fatherName: yup.string(),
  motherName: yup.string(),
  wifeName: yup.string(),

  whatsappMobile: yup
    .string()
    .nullable()
    // .matches(/^[0-9]{10}$/, "WhatsApp number must be 10 digits")
    .notRequired(),

  email: yup
    .string()
    .email("Invalid email")
    .notRequired(),

  address: yup.string().notRequired(),

  birthdate: yup.string().notRequired(),

  aadharNo: yup
    .string()
    // .matches(/^[0-9]{12}$/, "Aadhar must be 12 digits")
    .notRequired(),

  panNo: yup
    .string()
    // .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN")
    .notRequired(),

  voterId: yup.string().notRequired(),
  drivingLicense: yup.string().notRequired(),

  job: yup.string().notRequired(),
  duration: yup.string().notRequired(),

  purchaseType: yup.string().notRequired(),

  amount: yup
    .string()
    // .typeError("Amount must be a number")
    .notRequired()
});
